import React, { useState } from 'react';
import './ratingsFilterPannel.scss';
import { UuiFlexlayout } from '@aonunited/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faSearch } from '@fortawesome/free-solid-svg-icons';
import SPDialog from '../../Dailog/S&PDialog';
import AMBestDialog from '../../Dailog/AMBestDialog';
import { Link } from 'react-router-dom';
var RatingsFilterPannel = function (props) {
    var _a = React.useState(false), showAMBestDialog = _a[0], setShowAMBestDialog = _a[1];
    var _b = React.useState(false), showSandPDialog = _b[0], setShowSandPDialog = _b[1];
    var _c = useState(""), searchValue = _c[0], setSearchValue = _c[1];
    var handleClear = function () {
        setSearchValue("");
        props.onClickClear();
    };
    var HandleSearch = function (text) {
        setSearchValue(text);
        if (!text) {
            props.onClickClear();
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(UuiFlexlayout, { direction: 'row', className: 'ratings-filter-wrapper' },
            React.createElement("div", { className: 'outlook-pannel' },
                React.createElement(UuiFlexlayout, { direction: 'row', gap: 'xs' },
                    React.createElement("div", null, "Outlook Definitions:"),
                    React.createElement("div", null,
                        React.createElement(Link, { onClick: function () { return setShowAMBestDialog(true); }, to: '' }, " AM Best ")),
                    React.createElement("div", null,
                        React.createElement(Link, { onClick: function () { return setShowSandPDialog(true); }, to: '' }, " S & P ")))),
            React.createElement("div", { className: "search-pannel" },
                React.createElement("span", { style: { marginRight: "5px", color: 'grey' } }, "Search"),
                React.createElement("div", { className: 'text-input-field' },
                    React.createElement("input", { className: 'text-input', onChange: function (event) { return HandleSearch(event.target.value); }, value: searchValue, type: "text", name: "", id: "__marketNewsSearchInput__", placeholder: 'Search by company name' }),
                    searchValue && React.createElement(FontAwesomeIcon, { onClick: handleClear, className: 'text-icon', icon: faClose }),
                    React.createElement(FontAwesomeIcon, { onClick: function () { return props.onClickSearch(searchValue); }, className: 'text-icon', icon: faSearch })))),
        showAMBestDialog && React.createElement(AMBestDialog, { showDialog: showAMBestDialog, onClickClose: function () { return setShowAMBestDialog(false); } }),
        showSandPDialog && React.createElement(SPDialog, { showDialog: showSandPDialog, onClickClose: function () { return setShowSandPDialog(false); } })));
};
export default RatingsFilterPannel;
